// extracted by mini-css-extract-plugin
export default {"block":"SortArrows_block__YtgZt","turnedOverTriangle":"SortArrows_turnedOverTriangle__FjE6T"};